import React from "react";
import {
  Dashboard
} from "../../_themeBase/_partials";

function DashboardPage() {
  return <Dashboard />;
}

export default DashboardPage

